var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ActiveTab InfoTab"},[_c('LocatieInformatieHeader',{attrs:{"chargingpoint":_vm.chargingpoint}},[_c('h4',[_vm._v(_vm._s(_vm.$t('components.sidebar.Tabs.InfoTab')))])]),_c('div',{staticClass:"ActiveTab__Content"},[(! _vm.isPlanModeActive)?_c('LocatieInformatieContent'):_c('LocatieInformatieEdit')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }